const DESKTOP_HOVER_QUERY = '(min-width: 1025px) and (hover: hover) and (pointer: fine)';
let sharedMobileMenuWindowScroll = 0;
let sharedMobileMenuWrapperScroll = 0;

function lockSharedMobileMenuScroll() {
  if (document.documentElement.classList.contains('hallowvia-mobile-menu-open')) return;

  const pageWrapper = document.querySelector('.page-wrapper');
  sharedMobileMenuWindowScroll = window.scrollY;
  sharedMobileMenuWrapperScroll = pageWrapper?.scrollTop || 0;
  document.documentElement.classList.add('hallowvia-mobile-menu-open');
  document.body.classList.add('hallowvia-mobile-menu-open');
}

function unlockSharedMobileMenuScroll(restorePosition = true) {
  if (!document.documentElement.classList.contains('hallowvia-mobile-menu-open')) return;
  if (document.querySelector('[data-hallowvia-shared-mobile-menu][open]')) return;

  const pageWrapper = document.querySelector('.page-wrapper');
  document.documentElement.classList.remove('hallowvia-mobile-menu-open');
  document.body.classList.remove('hallowvia-mobile-menu-open');
  if (restorePosition) {
    window.scrollTo(0, sharedMobileMenuWindowScroll);
    if (pageWrapper) pageWrapper.scrollTop = sharedMobileMenuWrapperScroll;
  }
}

function closeSharedMobileMenu(menu, updateState) {
  if (!menu.open) return;
  menu.open = false;
  // The native toggle event is queued. Clean up synchronously so a dialog or
  // the next page can never inherit the drawer's fixed-body scroll lock.
  updateState();
}

function collapseDesktopDropdown(dropdown) {
  dropdown.classList.remove('is-open');
  dropdown.querySelector('.hallowvia-character-desktop__parent')?.setAttribute('aria-expanded', 'false');
}

function configureDesktopDropdown(dropdown) {
  if (dropdown.dataset.characterReady === 'true') return;
  const parent = dropdown.querySelector('.hallowvia-character-desktop__parent');
  const panel = dropdown.querySelector('[data-character-panel]');
  const list = dropdown.querySelector('[data-character-list]');
  if (!parent || !panel || !list) return;

  let closeTimer;
  let suppressFocusOpen = false;

  const layout = () => {
    const dropdownRect = dropdown.getBoundingClientRect();
    const availableWidth = Math.max(250, window.innerWidth - dropdownRect.left - 16);
    const availableHeight = Math.max(240, window.innerHeight - dropdownRect.bottom - 16);
    panel.style.setProperty('--character-available-width', `${availableWidth}px`);
    panel.style.setProperty('--character-available-height', `${availableHeight}px`);
  };

  const open = () => {
    window.clearTimeout(closeTimer);
    dropdown.classList.remove('is-escape-closed');
    document.querySelectorAll('[data-character-dropdown].is-open').forEach((otherDropdown) => {
      if (otherDropdown !== dropdown) collapseDesktopDropdown(otherDropdown);
    });
    layout();
    dropdown.classList.add('is-open');
    parent.setAttribute('aria-expanded', 'true');
  };

  const close = (immediate = false) => {
    window.clearTimeout(closeTimer);
    const finish = () => {
      if (dropdown.matches(':hover') || dropdown.contains(document.activeElement)) return;
      dropdown.classList.remove('is-escape-closed');
      collapseDesktopDropdown(dropdown);
    };
    if (immediate) finish();
    else closeTimer = window.setTimeout(finish, 80);
  };

  dropdown.addEventListener('pointerenter', () => {
    if (window.matchMedia(DESKTOP_HOVER_QUERY).matches) open();
  });
  dropdown.addEventListener('pointerleave', () => close());
  dropdown.addEventListener('focusin', () => {
    if (!suppressFocusOpen) open();
  });
  dropdown.addEventListener('focusout', () => close());
  dropdown.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    event.preventDefault();
    suppressFocusOpen = true;
    dropdown.classList.add('is-escape-closed');
    collapseDesktopDropdown(dropdown);
    parent.focus();
    window.setTimeout(() => {
      suppressFocusOpen = false;
    }, 0);
  });
  window.addEventListener('resize', () => {
    if (dropdown.classList.contains('is-open')) layout();
  });

  dropdown.dataset.characterReady = 'true';
}

function configureMobileToggle(toggle) {
  if (toggle.dataset.characterReady === 'true') return;
  const item = toggle.closest('[data-character-mobile-item]');
  const panel = item?.querySelector('[data-character-mobile-panel]');
  if (!item || !panel) return;

  toggle.addEventListener('click', () => {
    const shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';
    const navigation = item.closest('nav') || item.parentElement;
    navigation?.querySelectorAll('[data-character-mobile-toggle][aria-expanded="true"]').forEach((otherToggle) => {
      if (otherToggle !== toggle) otherToggle.setAttribute('aria-expanded', 'false');
    });
    toggle.setAttribute('aria-expanded', String(shouldOpen));
  });

  item.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || toggle.getAttribute('aria-expanded') !== 'true') return;
    event.stopPropagation();
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
  });

  toggle.dataset.characterReady = 'true';
}

function sortCharacterList(list) {
  const collator = new Intl.Collator(document.documentElement.lang || undefined, {
    sensitivity: 'base',
    numeric: true,
  });
  const items = [...list.children].filter((item) => item.matches('li'));

  items
    .sort((first, second) => collator.compare(first.textContent.trim(), second.textContent.trim()))
    .forEach((item) => list.append(item));
}

function configureSharedMobileMenu(menu) {
  if (menu.dataset.sharedMobileMenuReady === 'true') return;
  const summary = menu.querySelector(':scope > summary');
  const navigation = menu.querySelector(':scope > nav');
  if (!summary || !navigation) return;

  const updateState = () => {
    summary.setAttribute('aria-expanded', String(menu.open));
    if (menu.open) {
      lockSharedMobileMenuScroll();
    } else {
      navigation.querySelectorAll('[data-character-mobile-toggle][aria-expanded="true"]').forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'false');
      });
      unlockSharedMobileMenuScroll();
    }
  };

  menu.addEventListener('toggle', updateState);
  menu.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !menu.open) return;
    event.preventDefault();
    menu.open = false;
    summary.focus();
  });
  navigation.addEventListener('click', (event) => {
    const searchTrigger = event.target.closest?.('[data-hallowvia-menu-search]');
    if (searchTrigger) {
      closeSharedMobileMenu(menu, updateState);
      return;
    }

    const cartTrigger = event.target.closest?.('[data-hallowvia-menu-cart]');
    if (cartTrigger) {
      closeSharedMobileMenu(menu, updateState);
      return;
    }

    const link = event.target.closest?.('a[href]');
    if (link) {
      menu.classList.add('is-navigating');
      closeSharedMobileMenu(menu, updateState);
      summary.getBoundingClientRect();
      requestAnimationFrame(() => {
        requestAnimationFrame(() => menu.classList.remove('is-navigating'));
      });
    }
  });
  window.matchMedia('(min-width: 1025px)').addEventListener('change', (event) => {
    if (event.matches && menu.open) menu.open = false;
  });

  updateState();
  menu.dataset.sharedMobileMenuReady = 'true';
}

function initializeCharacterNavigation(root = document) {
  root.querySelectorAll('[data-character-list]').forEach(sortCharacterList);
  root.querySelectorAll('[data-character-dropdown]').forEach(configureDesktopDropdown);
  root.querySelectorAll('[data-character-mobile-toggle]').forEach(configureMobileToggle);
  root.querySelectorAll('[data-hallowvia-shared-mobile-menu]').forEach(configureSharedMobileMenu);

  if (document.documentElement.dataset.characterNavigationOutsideReady !== 'true') {
    document.addEventListener('pointerdown', (event) => {
      document.querySelectorAll('[data-character-dropdown].is-open').forEach((dropdown) => {
        if (dropdown.contains(event.target)) return;
        if (dropdown.contains(document.activeElement) && document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
        collapseDesktopDropdown(dropdown);
      });
    });
    document.documentElement.dataset.characterNavigationOutsideReady = 'true';
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeCharacterNavigation());
} else {
  initializeCharacterNavigation();
}

document.addEventListener('shopify:section:load', (event) => initializeCharacterNavigation(event.target));

// A cross-page transition or a restored mobile page must never keep the
// previous drawer's fixed-body state once no shared menu is open.
window.addEventListener('pagehide', () => {
  document.querySelectorAll('[data-hallowvia-shared-mobile-menu][open]').forEach((menu) => {
    menu.open = false;
  });
  unlockSharedMobileMenuScroll(false);
});

window.addEventListener('pageshow', () => {
  if (!document.querySelector('[data-hallowvia-shared-mobile-menu][open]')) {
    unlockSharedMobileMenuScroll(false);
  }
});
